export const validatePhone = (value: string) => {
  const isValid = !value.includes('_')

  let error: string | null = null
  if (!isValid) error = 'e.g. (123)456-7890'

  if (error) return Promise.reject(new Error(error))
  else return Promise.resolve()
}
